<template>
	<el-dialog :title="title" top="20vh" v-model="show" :width="1500" draggable destroy-on-close @closed="show=false">
		<mn-file-select v-model="file" :multiple="multiple" :hideUpload="hideUpload" :max="max" @submit="submit">
			<template #do>
				<!-- <el-button>自定义插槽</el-button> -->
			</template>
		</mn-file-select>
	</el-dialog>
</template>

<script>
	import mnFileSelect from '@/components/mnFileSelect'
	export default {
		components: {
			mnFileSelect
		},
		emits: ['selectimg'],
        props: {
			select: { type: Boolean, default: false },
			title:{ type:String,default:'选择资源' },
			multiple:{ type:Boolean,default:false },
			max:{ type:Number,default:99 }
		},
		data() {
			return {
				file:'',
                show:false,
				hideUpload:false,
			}
		},
		mounted() {

		},
		methods: {
          open(){
            this.show = true;
          },
		  submit(e){
			this.show = false;
			this.$emit('selectimg',e);
		  }
		}
	}
</script>

<style>

</style>
